export default class QuestionnaireAllergyStep {}

QuestionnaireAllergyStep.Question = 'QUESTION';

QuestionnaireAllergyStep.getBaseSteps = () => [];
